import { createSlice } from '@reduxjs/toolkit';

const initialStateCountries = {
    listLoading: false,
    actionsLoading: false,
    countriesList: undefined,
    success: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const countriesListSlice = createSlice({
    name: "countriesList",
    initialState: initialStateCountries,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List country
        countriesListFetched: (state, action) => {
            state.listLoading = false;
            state.countriesList = action.payload.countriesList;
            state.error = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.countriesList = undefined;
            state.error = null;
            state.success = null;
        }
    }
});